import React, { forwardRef } from "react";
import { InputInputProps } from "./Input.types";
import { Input as StyledInput } from "./Input.styles";

/**
 * Styled input primitive with validation states
 */
export const InputComponent = forwardRef<HTMLInputElement, InputInputProps>(
  ({ isValid = true, width, className, ...props }, ref) => (
    <StyledInput
      ref={ref}
      className={className}
      isValid={isValid}
      width={width}
      {...props}
    />
  )
);

InputComponent.displayName = "InputComponent";
